import App from './App.svelte'
import 'svelte-navigator/svelte-navigator.css'

const app = new App({
  target: document.body,
})

export default app